import React from "react";
import styled from "styled-components";
import mockup from "../assets/bannerImg3.png";
import { Link } from "react-router-dom";

const Banner = () => {
  const isMobile = window.innerWidth <= 700;
  return (
    <Container>
      {/* <div className="dot-background" /> */}
      {/* <div className="dot-mask" /> */}
      <h3>Built for People Who Refuse Average</h3>
      {isMobile ? (
        <h1>
          Built for the <span>Top 1%</span>! Goals, <span>Progress</span> &
          Finances. <br />
          <span>All</span> in One <span>System</span>
        </h1>
      ) : (
        <h1>
          Built for the <span>Top 1%</span>! <br /> Goals, <span>Progress</span>{" "}
          & Finances
          <br /> <span>All</span> in One <span>System</span>
        </h1>
      )}
      <p>Do what others won’t today so you can live differently tomorrow.</p>
      <div className="btns">
        <Link to="/signup">
          <button>Get Started</button>
        </Link>
        <button>Contact Us</button>
      </div>
      <img src={mockup} alt="" />
    </Container>
  );
};
const Container = styled.div`
  padding: 8% 7% 5em 7%;
  font-family: "Readex Pro", sans-serif;
  font-optical-sizing: auto;
  /* background-color: var(--primaryBackgroundColor);
  background: radial-gradient(
    circle at 70% 23%,
    var(--primaryColor) 0%,
    var(--secondaryBackgroundColor) 45%,
    var(--primaryBackgroundColor) 70%
  ); */
  z-index: 10;
  overflow: hidden;
  padding-bottom: 2em;
  color: white;
  h3 {
    text-align: center;
    color: #9281dd;
    font-weight: 200;
    border: 1px solid #463d6e;
    display: flex;
    width: auto;
    justify-content: center;
    align-items: center;
    width: 480px;
    margin: auto;
    margin-top: 0%;
    padding: 7px 5px;
    border-radius: 20px;
    text-transform: uppercase;
  }
  h1 {
    font-weight: 400;
    font-size: 4vw;
    text-align: center;
    line-height: 1em;
    margin-top: 40px;
    font-family: "Montserrat", sans-serif;
    span {
      color: #9281dd;
      font-weight: 400;
    }
  }
  p {
    text-align: center;
    color: #b6b6b6;
    margin-top: 10px;
    font-family: "Montserrat", sans-serif;
  }
  /* }
  .dot-background {
    position: absolute;
    inset: 0;
    background-size: 30px 30px;
    background-image: radial-gradient(#4d4081 1px, transparent 1px);
    z-index: -2;
  }

  .dot-mask {
    position: absolute;
    inset: 0;
    mask-image: radial-gradient(ellipse at center, transparent 20%, #e91414);
    -webkit-mask-image: radial-gradient(
      ellipse at center,
      transparent 20%,
      black
    );
    z-index: -2;
  } */
  .btns {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 7px;
    button {
      background: linear-gradient(to top, #201c2c, #30243c);
      color: white;
      border: none;
      font-size: 16px;
      border-radius: 25px;
      padding: 15px 25px;
      margin-top: 1em;
      font-weight: 300;
      border: 1px solid #30243c;
      font-family: "Montserrat";
    }
    :nth-child(2) {
      background: none;
      border: none;
      /* text-decoration: underline; */
      /* color: black; */
    }
  }
  img {
    margin: auto;
    display: flex;
    /* margin-top: 4%; */
    width: 70%;
    margin-top: 1%;
    margin-right: 12%;
  }
  iframe {
    z-index: -1;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 00%;
    position: absolute;
    top: 14%;
    object-fit: contain;
    opacity: 0.3;
    scale: 2.4;
  }
  @media (max-width: 500px) {
    iframe {
      transform: scale(0.6);
    }
  }
  @media (max-width: 1600px) {
    padding: 9em 7% 5% 7%;
  }
  @media (max-width: 1300px) {
    h1 {
      font-size: 6vw;
    }
  }
  @media (max-width: 750px) {
    height: 100vh;
    h1 {
      font-size: 8.5vw;
    }
    img {
      width: 100%;
      margin-top: 15px;
    }
  }
  @media (max-width: 550px) {
    padding: 6em 7% 5em 7%;
    h3 {
      font-size: 14px;
      width: 100%;
    }
    h1 {
      margin-top: 20px;
      font-size: 9vw;
    }
  }
`;

export default Banner;
